// extracted by mini-css-extract-plugin
export default {"root":"PpcCompliancePanel_root__XwaFn","aiButtonText":"PpcCompliancePanel_aiButtonText__ex6rR","showPlaRow":"PpcCompliancePanel_showPlaRow__JlajP"};